<template>
    <div class="scl-ad">
        <PreLoader v-if="isLoading"/>
        <ClassSelectHeader :headTitle="'Журнал'" :showClass="true"
                           @classSelected="onChangeClass" @allClasses="getInstructorCourses"/>

        <div class="grade-content">
            <div class="selects">
                    <v-select class="ijg-item" :no-data-text="$t('no_data')" :items="instructorCourses"
                              :item-text="showCourseName" item-value="courseId" :label="$t('course')"
                              v-model="monthDataRequest.courseId" @change="onChangeCourse" outlined dense/>
                    <v-autocomplete class="ijg-item" outlined dense :no-data-text="$t('no_data')"
                                    :items="topics" item-text="title" item-value="id" label="Тема"
                                    v-model="selectedTopicId"/>
                <v-btn color="green" class="ijg-item" @click="exportGradesPdf" v-text="$t('export')"/>
            </div>

            <div class="main-tab-style" v-if="studentGrades.length">
                <div class="title-block" style="width: 100%">
                    <span style="font-weight: bold;">Журнал</span>
                    <div class="grade-tables" v-if="studentGrades.length" ref="gradeTables">
                            <v-simple-table class="students bordered">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th ref="monthLabel">
                                                <div class="date" v-if="currentMonthDays.length">
                                                    {{numMonths[currentMonthDays[0].day.slice(3, 5)]}}
                                                    {{currentMonthDays[0].day.slice(0, 2)}} -
                                                    {{currentMonthDays[currentMonthDays.length - 1].day.slice(0, 2)}}
                                                </div>
                                                <PlayArrowIcon class="date-arrow left"
                                                               @click="filterGradesByMonth('prev', true)"
                                                               :class="{'blocked': currentMonthDays[0].disabled}"/>
                                                <PlayArrowIcon class="date-arrow"
                                                               @click="filterGradesByMonth('next', true)"
                                                               :class="{'blocked': currentMonthDays[0].disabled}"/>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(student, i) in studentGrades" :key="student.student.id">
                                            <td>
                                                <span class="index" v-html="i + 1 + '.'"/>
                                                <span class="name" v-html="student.student.surname + ' ' + student.student.name"/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            <v-simple-table class="grades bordered" ref="tableGrades">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th v-for="(day, d) in currentMonthDays" :key="d"
                                                :class="{'disabled': !isAbleDate(day.day), 'archived': day.archived}">
                                                {{ day.day.slice(0, 2) }}
                                                <div class="lesson" v-html="day.shiftTimeTitle + '-' + $t('lesson')"/>
                                            </th>
                                            <th class="average"><span>-</span><span>x</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="student in studentGrades" :key="student.student.id">
                                            <td v-for="(day, d) in currentMonthDays"
                                                @click="openSetGradeModal(student, day)" :key="d"
                                                :class="{ 'disabled': !isAbleDate(day.day),'absent-95'
                                                : getStudentGradeObj(day, student['grades']).mark === '95','archived': day.archived }"
                                                v-html="getStudentSpecificMark(day, student['grades'])"/>
                                            <td class="average"
                                                v-html="student['avgGrade'] ? student['avgGrade'].toFixed(1) : ''"/>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                    </div>
                </div>
            </div>
        </div>

        <!--MODAL FOR SETTING GRADE-->
        <v-dialog v-model="setGradeDialog">
            <div class="modal-container">
                <template v-if="gradeMode === 'setGrade'" style="width: 100%">
                    <v-btn class="delete-grade" icon color="red" @click="gradeMode='deleteGrade'" v-show="isDeletable">
                        <v-icon color="red">mdi-trash-can-outline</v-icon>
                    </v-btn>
                    <div class="header text-center" v-html="selectedDate.day"/>
                    <div class="header text-center" style="font-size: 18px; padding-bottom: 12px"
                         v-if="selectedStudent.student" v-html="selectedStudent.student.surname + ' ' + selectedStudent.student.name"/>
                        <v-text-field label="Тема" :value="getSelectedTopicTitle()"
                                      class="selected-theme v-select-item" outlined dense readonly/>
                        <v-select class="v-select-item" :items="gradeReasons" item-text="reasonTitle"
                                  item-value="id" :label="$t('markType')" v-model="selectedReasonId"
                                  outlined dense :no-data-text="$t('no_data')"/>
                        <div class="mark-grades">
                            <v-radio-group v-model="selectedAbsentCode" @change="selectedMark=''; selectedExtraMark=''">
                                <v-radio v-for="item in atestation" :key="item.code" :label="item.title"
                                         :value="item.code" :class="{'absent95': item.code === 95}"/>
                            </v-radio-group>
                            <div class="main-marks">
                                <span>{{$t('mark')}}: </span>
                                <span v-for="(mark, m) in [2, 3, 4, 5]" :key="m" v-model="selectedMark" class="mark"
                                      :class="{'selected': mark === selectedMark}"
                                      @click="selectedMark=mark; selectedAbsentCode=''" v-html="mark"/>
                            </div>
                            <div class="extra-marks" v-show="selectedMark">
                                <span>Доп.оценка: </span>
                                <span v-for="(mark, m) in [2, 3, 4, 5]" :key="m" v-model="selectedExtraMark"
                                      class="mark" :class="{'selected': mark === selectedExtraMark}"
                                      @click="selectedExtraMark=mark; selectedAbsentCode=''" v-html="mark"/>
                            </div>
                            <div style="font-weight: bold">Отсутствовал:</div>
                            <v-radio-group v-model="selectedAbsentCode" @change="selectedMark=''; selectedExtraMark=''">
                                <v-radio v-for="item in absents" :key="item.code" :label="item.title" :value="item.code"
                                         :class="{'absent95': item.code === 95}"/>
                            </v-radio-group>
                            <div class="btn-actions">
                                <v-btn @click="setSelectedGradeMark" v-text="isDeletable ? $t('edit') : $t('save')"
                                       color="primary"/>
                            </div>
                        </div>
                </template>
                <template v-if="gradeMode === 'deleteGrade'">
                    <h4>Удалить?</h4>
                    <div class="btn-actions" style="margin: 0">
                        <v-btn color="primary" @click="gradeMode='setGrade'" v-text="$t('cancel')"/>
                        <v-btn color="red" @click="deleteGrade" v-text="$t('remove')"/>
                    </div>
                </template>
            </div>
        </v-dialog>
    </div>
</template>

<script>
import ClassSelectHeader from '@/components/instructor/ClassSelectHeader'
import GradeService from '@/_services/grade.service'
import ScheduleWeekService from '@/_services/schedule-week.service'
import moment from 'moment'
import AdminGradeReasonService from '@/_services/admin-grade-reason.service'
import PreLoader from '@/components/preloader/PreLoader'
import PlayArrowIcon from '@/components/icons/PlayArrowIcon'
import { TopicService } from '@/_services/topic.service'
import { QuarterService } from '@/_services/quarter.service'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
const topicService = new TopicService()
const quarterService = new QuarterService()
pdfMake.vfs = pdfFonts.pdfMake.vfs

export default {
  components: {
    ClassSelectHeader,
    PreLoader,
    PlayArrowIcon
  },
  mounted () {
    this.absents = [
      { title: this.$t('respectfulAbsence'), code: '92' },
      { title: this.$t('respectfulThink'), code: '93' },
      { title: this.$t('disrespectfulAbsense'), code: '95' }
    ]
    this.atestation = [
      { title: this.$t('isAttistat'), code: '90' },
      { title: this.$t('isNotAttistat'), code: '91' }
    ]
  },

  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    },
    currentLang () {
      return this.$root.$i18n.locale
    }
  },

  data () {
    return {
      quarterTitle: {
        1: 'I',
        2: 'II',
        3: 'III',
        4: 'IV'
      },
      showGosExam: false,
      absents: [
        { title: this.$t('respectfulAbsence'), code: '92' },
        { title: this.$t('respectfulThink'), code: '93' },
        { title: this.$t('disrespectfulAbsense'), code: '95' }
      ],
      atestation: [
        { title: this.$t('isAttistat'), code: '90' },
        { title: this.$t('isNotAttistat'), code: '91' }
      ],
      langObj: {
        ru: 'courseTitle',
        kg: 'courseTitleKG',
        en: 'courseCode'
      },
      schoolQuarters: [],
      reasonLang: {
        ru: 'title',
        kg: 'titleKG'
      },
      numMonths: {
        '01': 'Январь',
        '02': 'Февраль',
        '03': 'Март',
        '04': 'Апрель',
        '05': 'Май',
        '06': 'Июнь',
        '07': 'Июль',
        '08': 'Август',
        '09': 'Сентябрь',
        10: 'Октябрь',
        11: 'Ноябрь',
        12: 'Декабрь'
      },
      gradeRequest: {
        pageRequest: {
          limit: 100,
          offset: 0
        },
        searchRequest: {
          chronicleId: 0,
          instructorId: 0,
          from: '',
          to: '',
          quarterId: ''
        }
      },
      monthDataRequest: {
        chronicleId: 0,
        classId: 0,
        courseId: 0,
        instructorId: 0,
        shiftId: null
      },
      isLoading: false,
      step: 0,
      selectedReasonId: '',
      selectedTopicId: '',
      selectedClassLevel: '',
      instructorCourses: [],
      currentMonthDays: [],
      studentGrades: [],
      gradeReasons: [],
      studentQuarterGrades: [],
      gradeMonthFrom: new Date().getMonth(),
      gradeMonthTo: new Date().getMonth() + 1,
      scheduleMonthNumber: new Date().getMonth() + 1,
      allCourses: [],
      topics: [],
      selectedStudent: {},
      selectedGradeObj: {},
      selectedClassObj: {},
      selectedCourseObj: {},
      selectedDate: '',
      topicPage: 0,
      showFixedTableHead: false,
      setGradeDialog: false,
      isDeletable: false,
      gradeTablesWidth: 0,
      monthLabelWidth: 0,
      selectedAbsentCode: '',
      selectedMark: '',
      selectedExtraMark: '',
      deleteComment: '',
      gradeMode: 'setGrade',
      isLastMonth: false,
      isFirstMonth: false,
      requestObj: {
        classId: '',
        courseId: ''
      },
      sendQuarterGradeObj: {
        chronicleId: 0,
        classId: 0,
        instructorId: 0,
        students: []
      },
      gradeYear: new Date().getFullYear()
    }
  },

  created () {
    this.gradeRequest.searchRequest.quarterId = this.school.quarterId
    window.addEventListener('scroll', this.scrollGradesListener)
    this.fetchSchoolQuarters()
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollGradesListener)
  },

  methods: {
    getQuarterGrade (currentQuarter, studentQuarterGrades) {
      return studentQuarterGrades.find((quarterGrade) => quarterGrade.quarterId === currentQuarter.id)
    },
    getFinalGrade (student) {
      return this.finalGrades.find(el => el.m2mStudentCourseId === student.m2mStudentCourseId)
    },
    fetchSchoolQuarters () {
      quarterService.getBySchoolAndChronicle(this.school.id, this.school.chronicleId).then((res) => {
        this.schoolQuarters = res.sort((a, b) => a.semester - b.semester)
      }).catch((err) => {
        this.$toast.error(err)
      })
    },
    scrollGradesListener () {
      if (this.$refs.gradeTables) {
        if (window.scrollY >= this.$refs.gradeTables.offsetTop) {
          const fixedTableHead = this.$refs.fixedTableHead.$el.querySelector('.fixed-head')
          this.gradeTablesWidth = this.$refs.gradeTables.offsetWidth
          this.monthLabelWidth = this.$refs.monthLabel.offsetWidth
          fixedTableHead.scrollLeft = this.step
          this.showFixedTableHead = true
        } else {
          this.showFixedTableHead = false
        }
      }
    },

    showCourseName (courseObj) {
      return courseObj[this.langObj[this.currentLang]] === null ? this.$t('notTranslate') : courseObj[this.langObj[this.currentLang]]
    },

    getSelectedTopicTitle () {
      const selectedTopic = this.topics.find((topic) => topic.id === this.selectedTopicId)
      return selectedTopic ? selectedTopic.title : ''
    },

    getInstructorCourses (allClasses) {
      this.instructorCourses = allClasses
      this.allCourses = allClasses
    },

    async onChangeClass (klass) {
      if (!klass) {
        this.$toast.info(this.$t('noClasses'))
        return
      }
      this.isLoading = true
      this.selectedClassObj = klass
      this.selectedClassLevel = klass.classLevel
      this.monthDataRequest.classId = klass.classId
      this.monthDataRequest.instructorId = this.userProfile.personId
      this.monthDataRequest.chronicleId = this.school.chronicleId
      this.gradeRequest.searchRequest.instructorId = (klass.replace || klass.isAllDay) ? null : this.userProfile.personId
      this.gradeRequest.searchRequest.chronicleId = this.school.chronicleId
      this.gradeRequest.searchRequest.from = this.getFirstDateOfMonth()
      this.gradeRequest.searchRequest.to = this.getLastDateOfMonth()
      this.filterCourses(klass)
    },

    async filterCourses (selectedClass) {
      this.instructorCourses = this.allCourses.filter((course) => course.classId === selectedClass.classId)
      this.monthDataRequest.courseId = this.instructorCourses.length ? this.instructorCourses[0].courseId : 0
      if (this.monthDataRequest.courseId) {
        this.fetchInstructorTopics()
        this.fetchGradeReasons(this.instructorCourses[0].adminCourseId)
        await this.fetchCurrentMonthSchedule()
        await this.fetchStudentGrades()
      } else {
        this.isLoading = false
      }
    },

    async onChangeCourse () {
      this.isLoading = true
      const adminCourseId = this.instructorCourses
        .find(course => course.courseId === this.monthDataRequest.courseId).adminCourseId
      await this.fetchCurrentMonthSchedule()
      await this.fetchStudentGrades()
      await this.fetchInstructorTopics()
      await this.fetchGradeReasons(adminCourseId)
    },

    fetchStudentGrades () {
      this.studentGrades = []
      this.studentQuarterGrades = []
      this.selectedCourseObj = this.instructorCourses.find(i => i.courseId === this.monthDataRequest.courseId)
      GradeService.getByClassCourseInstructor(
        this.monthDataRequest.classId,
        this.monthDataRequest.courseId,
        this.gradeRequest
      ).then((res) => {
        const allExistDays = this.currentMonthDays.map((item) => item.day)
        this.studentGrades = res.list.map((student) => {
          student.grades.reverse().map((gradeObj) => {
            if (!allExistDays.includes(gradeObj.date)) {
              gradeObj.archived = true
              const isExist = this.currentMonthDays.some((i) => i.day === gradeObj.date)
              if (!isExist) {
                this.currentMonthDays.unshift({
                  day: gradeObj.date,
                  archived: true,
                  shiftTimeId: gradeObj.shiftTimeId
                })
              }
            }
            return gradeObj
          })
          return student
        })
        this.isLoading = false
      }).catch((err) => {
        this.isLoading = false
        this.$toast.error(err)
      })
    },

    fetchInstructorTopics () {
      this.topics = []
      topicService.getInstructorTopicInterface(
        this.userProfile.personId,
        this.monthDataRequest.courseId,
        this.school.quarterId,
        this.selectedClassObj.classId,
        this.selectedClassLevel
      ).then((res) => {
        this.topics = res
        this.selectedTopicId = this.topics.length ? this.topics[0].id : ''
      }).catch((err) => {
        this.$toast.error(err)
      })
    },

    fetchCurrentMonthSchedule () {
      if (this.selectedClassObj.isAllDay) {
        this.currentMonthDays = []
        this.allCourses.filter((klass) => {
          return klass.classId === this.selectedClassObj.classId
        }).sort((a, b) => {
          const aDate = new Date(moment(a.replacementDate, 'DD.MM.YYYY'))
          const bDate = new Date(moment(b.replacementDate, 'DD.MM.YYYY'))
          return aDate - bDate
        }).forEach((item) => {
          this.currentMonthDays.push({
            day: item.replacementDate,
            shiftTimeId: item.shiftTimeId,
            shiftTimeTitle: item.shiftTimeName,
            disabled: true
          })
        })
        return
      }
      ScheduleWeekService.getCurrentMonth(this.scheduleMonthNumber, this.monthDataRequest)
        .then((res) => {
          this.currentMonthDays = res.map((item) => {
            item.day = moment(item.day, 'YYYY-MM-DD').format('DD.MM.YYYY')
            return item
          })
        }).catch((err) => {
          this.isLoading = false
          this.$toast.error(err)
        })
    },

    fetchGradeReasons (adminCourseId) {
      AdminGradeReasonService.getByAdminCourse(adminCourseId).then((res) => {
        this.gradeReasons = res.map((item) => {
          item.reasonTitle = item[this.reasonLang[this.currentLang]]
          return item
        })
        if (this.gradeReasons.length === 0) this.$toast.info(this.$t('gradeTypeError'))
      })
    },

    isAbleDate (gradeDate) {
      const formattedGradeDate = moment(gradeDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
      const currentDate = moment(new Date()).format('YYYY-MM-DD')
      return formattedGradeDate <= currentDate
    },

    getStudentSpecificMark (dayObj, studentGrades) {
      const grade = studentGrades.find((i) => i.date === dayObj.day && i.shiftTimeId === dayObj.shiftTimeId)
      if (grade) {
        if (grade.gradeType === 'ATTENDANCE') {
          if (grade.mark === '95') return 'Н'
          else if (grade.mark === '90') return 'А'
          else if (grade.mark === '91') return 'НА'
          else if (grade.mark === '93') return 'Б'
          else if (grade.mark === '92') return 'У'
          else return 'Н'
        } else {
          if (grade.extraMark) {
            return `${grade.mark}/${grade.extraMark}`
          } else {
            return grade.mark
          }
        }
      }
      return ''
    },

    getStudentGradeObj (date, studentGrades) {
      const grade = studentGrades.find((i) => i.date === date.day && i.shiftTimeId === date.shiftTimeId)
      return grade || ''
    },

    openSetGradeModal (student, date) {
      const quarterStartDate = moment(this.school.quarterStart, 'DD.MM.YYYY').format('YYYY-MM-DD')
      const gradeDate = moment(date.day, 'DD.MM.YYYY').format('YYYY-MM-DD')
      if (gradeDate < quarterStartDate) {
        this.$toast.error('Вы не можете изменить предыдущую четверть!')
        return
      }
      this.gradeMode = 'setGrade'
      this.selectedStudent = student
      this.selectedDate = date
      this.selectedGradeObj = this.getStudentGradeObj(date, student.grades)
      if (this.selectedGradeObj) {
        this.isDeletable = true
        this.selectedReasonId = this.selectedGradeObj.reasonId
        this.selectedTopicId = this.selectedGradeObj.topicId
        if (this.selectedGradeObj.gradeType === 'GRADE') {
          this.selectedMark = this.selectedGradeObj.mark
          this.selectedExtraMark = this.selectedGradeObj.extraMark
          this.selectedAbsentCode = ''
        } else {
          this.selectedAbsentCode = this.selectedGradeObj.mark
          this.selectedMark = ''
          this.selectedExtraMark = ''
        }
      } else {
        this.isDeletable = false
        this.selectedMark = ''
        this.selectedExtraMark = ''
        this.selectedAbsentCode = ''
      }
      this.setGradeDialog = true
    },

    setSelectedGradeMark () {
      if (!this.selectedTopicId) {
        this.$toast.info(this.$t('setTopicFirst'))
        return
      }
      if (!this.selectedReasonId) {
        this.$toast.info('Выберите тип оценки!')
        return
      }
      if (!this.selectedMark && !this.selectedAbsentCode) {
        this.$toast.info(this.$t('setGradeOrAttendance'))
        return
      }
      const newGradeObj = {
        classId: this.monthDataRequest.classId,
        gradeId: this.selectedGradeObj && this.selectedGradeObj.gradeId ? this.selectedGradeObj.gradeId : 0,
        m2mStudentCourseId: this.selectedStudent.m2mStudentCourseId,
        instructorId: this.userProfile.personId,
        shiftTimeId: this.selectedDate.shiftTimeId,
        gradeDate: this.selectedDate.day,
        date: this.selectedDate.day,
        mark: this.selectedMark ? this.selectedMark : this.selectedAbsentCode,
        gradeType: this.selectedMark ? 'GRADE' : 'ATTENDANCE',
        reasonId: this.selectedReasonId,
        topicId: this.selectedTopicId,
        extraMark: this.selectedExtraMark,
        comment: ''
      }
      this.setGradeDialog = false
      this.submitSaveGrades([newGradeObj])
    },

    deleteGrade () {
      if (this.selectedGradeObj.gradeId) {
        this.isLoading = true
        // this.selectedGradeObj.mark = parseInt(this.selectedGradeObj.mark) // '99'
        // this.selectedGradeObj.m2mStudentCourseId = this.selectedStudent.m2mStudentCourseId // '99'
        // this.selectedGradeObj.classId = this.selectedClassObj.classId // '99'
        // this.selectedGradeObj.instructorId = this.selectedClassObj.instructorId // '99'
        // this.selectedGradeObj.gradeDate = this.selectedDate.day
        GradeService.deleteStudentGrades([this.selectedGradeObj.gradeId]).then(() => {
          this.deleteMarkLocalStudentArr(this.selectedGradeObj)
          this.$toast.success(this.$t('successDeleted'))
          this.isLoading = false
          this.setGradeDialog = false
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
      }
    },

    addMarkToLocalStudentArr (newGradeObj) {
      newGradeObj.studentId = this.selectedStudent.student.id
      newGradeObj.courseId = this.monthDataRequest.courseId
      newGradeObj.gradeDate = moment(newGradeObj.gradeDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
      GradeService.getStudentSpecificGrade(newGradeObj).then((res) => {
        newGradeObj.gradeId = res[0].id
        newGradeObj.gradeDate = newGradeObj.date
        this.studentGrades = this.studentGrades.map((student) => {
          if (student.student.id === this.selectedStudent.student.id) {
            student.grades.push(newGradeObj)
          }
          return student
        })
        this.isLoading = false
        this.$toast.success(this.$t('success'))
      }).catch((err) => {
        this.isLoading = false
        this.$toast.error(err)
      })
    },

    deleteMarkLocalStudentArr (newGradeObj) {
      this.studentGrades.forEach((student) => {
        if (student.student.id === this.selectedStudent.student.id) {
          student.grades.forEach((existGrade, index, selfArr) => {
            const isExist = existGrade.date === newGradeObj.date &&
                                            existGrade.shiftTimeId === newGradeObj.shiftTimeId
            if (isExist) {
              selfArr.splice(index, 1)
            }
          })
        }
      })
    },

    filterGradesByMonth (nav, mainArrow) {
      const fixedTableHead = this.$refs.fixedTableHead.$el.querySelector('.fixed-head')
      const gradeTable = this.$refs.tableGrades
      const hasScrollBar = gradeTable.scrollWidth > gradeTable.clientWidth
      const endOfScroll = gradeTable.scrollWidth - gradeTable.clientWidth
      if (nav === 'prev') {
        if (hasScrollBar) {
          if (this.step) {
            this.step -= 300
            gradeTable.scrollLeft = this.step
            fixedTableHead.scrollLeft = this.step
          } else {
            this.step = 0
            this.scrollPrevMonth(mainArrow)
            gradeTable.scrollLeft = 0
          }
        } else {
          this.scrollPrevMonth(mainArrow)
        }
      } else {
        if (hasScrollBar) {
          if (this.step < endOfScroll) {
            this.step += 300
            gradeTable.scrollLeft = this.step
            fixedTableHead.scrollLeft = this.step
          } else {
            this.step = 0
            this.scrollNextMonth(mainArrow)
          }
        } else {
          this.scrollNextMonth(mainArrow)
        }
      }
    },

    async scrollNextMonth (mainArrow) {
      if (mainArrow && this.scheduleMonthNumber !== 5) {
        this.isLoading = true
        this.isLastMonth = this.scheduleMonthNumber === 12
        this.scheduleMonthNumber = this.isLastMonth ? 1 : this.scheduleMonthNumber + 1
        this.gradeMonthFrom = this.isLastMonth ? 0 : this.gradeMonthFrom + 1
        this.gradeMonthTo = this.isLastMonth ? 1 : this.gradeMonthTo + 1
        this.gradeYear = this.isLastMonth ? this.gradeYear + 1 : this.gradeYear
        this.gradeRequest.searchRequest.from = this.getFirstDateOfMonth()
        this.gradeRequest.searchRequest.to = this.getLastDateOfMonth()
        await this.fetchCurrentMonthSchedule()
        await this.fetchStudentGrades()
      }
    },

    async scrollPrevMonth (mainArrow) {
      if (mainArrow && this.scheduleMonthNumber !== 9) {
        this.isLoading = true
        this.isFirstMonth = this.scheduleMonthNumber === 1
        this.scheduleMonthNumber = this.isFirstMonth ? 12 : this.scheduleMonthNumber - 1
        this.gradeMonthFrom = this.isFirstMonth ? 11 : this.gradeMonthFrom - 1
        this.gradeMonthTo = this.isFirstMonth ? 12 : this.gradeMonthTo - 1
        this.gradeYear = this.isFirstMonth ? this.gradeYear - 1 : this.gradeYear
        this.gradeRequest.searchRequest.from = this.getFirstDateOfMonth()
        this.gradeRequest.searchRequest.to = this.getLastDateOfMonth()
        await this.fetchCurrentMonthSchedule()
        await this.fetchStudentGrades()
      }
    },

    getFirstDateOfMonth () {
      return moment(new Date(this.gradeYear, this.gradeMonthFrom, 1)).format('DD.MM.YYYY')
    },

    getLastDateOfMonth () {
      return moment(new Date(this.gradeYear, this.gradeMonthTo, 0)).format('DD.MM.YYYY')
    },

    saveGrade (grade) {
      this.isLoading = true
      GradeService.saveGrade(grade).then(() => {
        this.deleteMarkLocalStudentArr(grade)
        this.addMarkToLocalStudentArr(grade)
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    submitSaveGrades (sendGradeArr) {
      this.isLoading = true
      GradeService.createWithArray(sendGradeArr).then(() => {
        this.deleteMarkLocalStudentArr(sendGradeArr[0])
        this.addMarkToLocalStudentArr(sendGradeArr[0])
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    exportGradesPdf () {
      this.isLoading = true
      this.$nextTick(() => {
        setTimeout(() => {
          const currentClass = this.selectedClassObj.classLevel + this.selectedClassObj.classLabel
          const month = this.numMonths[this.currentMonthDays[0].day.slice(3, 5)]
          const firstDay = this.currentMonthDays[0].day.slice(0, 2)
          const lastDay = this.currentMonthDays[this.currentMonthDays.length - 1].day.slice(0, 2)
          const widths = ['auto', ...this.currentMonthDays.map((i) => 22)]
          const exportHeaders = [{ text: `${month} ${firstDay}-${lastDay}`, style: 'general' }]
          const exportRowsData = []
          this.currentMonthDays.forEach((date) => {
            exportHeaders.push({ text: date.day.slice(0, 2), style: 'general' })
          })
          this.studentGrades.forEach((student) => {
            const studentArr = [{ text: `${student.student.surname} ${student.student.name}`, style: 'general' }]
            this.currentMonthDays.forEach((dateObj) => {
              const mark = this.getStudentSpecificMark(dateObj, student.grades)
              studentArr.push({ text: mark, style: 'general' })
            })
            exportRowsData.push(studentArr)
          })
          const docDefinition = {
            header: [{
              text: `Оценки ${currentClass} класс, ${this.selectedCourseObj.courseTitle}, школа ${this.school.nameRu}`,
              style: 'headTitle'
            }],
            pageOrientation: 'landscape',
            pageSize: 'A4',
            permissions: {
              printing: 'highResolution',
              modifying: false,
              copying: false,
              annotating: true,
              fillingForms: true,
              contentAccessibility: true,
              documentAssembly: true
            },
            content: [{
              columns: [
                { width: '*', text: '' },
                {
                  width: 'auto',
                  table: {
                    headerRows: 1,
                    widths: widths,
                    body: [exportHeaders, ...exportRowsData],
                    alignment: 'center'
                  }
                },
                { width: '*', text: '' }
              ]
            }],
            styles: {
              general: {
                fontSize: 11,
                alignment: 'center',
                margin: [0, 0, 0, 0]
              },
              headTitle: {
                alignment: 'center',
                bold: true,
                fontSize: 13,
                margin: [0, 10, 0, 0]
              }
            }
          }
          pdfMake.createPdf(docDefinition).download(`Оценки ${currentClass} класс, школа ${this.school.nameRu}.pdf`)
          setTimeout(() => {
            this.isLoading = false
          }, 50)
        })
      })
    }

  }
}
</script>

<style lang="scss" scoped>
th, td {
    vertical-align: middle;
    text-align: center!important;
    border: rgba(198, 203, 212, 0.58) solid 1px;
    height: 50px!important;
    min-width: 90px!important;
}
th{
    font-weight: bold;
    font-size: 14px!important;
}
.main-tab-style{
    display: flex;
    flex-direction: row;
    gap: 12px;
}
.v-select-item {
    max-width: none;
}
.title-block{
    display: flex;
    flex-direction: column;
    gap: 12px
}
        .grade-content {
            .selects {
                display: flex;
                align-items: flex-start;
                padding: 20px 0;
                gap: 8px;
                .ijg-item{
                    max-width: 300px;
                }
                .select-course {
                    display: flex;
                    align-items: center;
                }
            }
            .other {
                display: flex;
                align-items: center;
                justify-content: space-between;
                //margin-bottom: 10px;
                .selected-year {
                    color: #1976d2;
                }
                button.export {
                    background: #1976d2;
                    color: #fff;
                    padding: 0 8px;
                    border-radius: 4px;
                    outline: none;
                }
            }
            .grade-tables {
                display: flex;
                table.students {
                    border-top: 0;
                    th {
                        color: #03A9F4;
                        display: flex;
                        align-items: center;
                        border-right: 0;
                        .date {
                            white-space: nowrap;
                        }
                        .date-arrow {
                            border: 1px solid #d1d1d1;
                            transform: translateX(10px);
                            width: 35px;
                            height: 35px;
                            line-height: 37px;
                            &.left {
                                //margin: 0 8px;
                            }
                            &.blocked {
                                pointer-events: none;
                            }
                        }
                    }
                    td {
                        white-space: nowrap;
                        display: flex;
                        align-items: center;
                        border-right: 0;
                        .index {
                            min-width: 20px;
                            text-align: left;
                        }
                        .name {

                        }
                    }
                }
                table.grades {
                    max-width: 100%;
                    overflow-x: auto;
                    display: inline-block;
                    scroll-behavior: smooth;
                    border-top: 0;
                    &::-webkit-scrollbar {
                        width: 0;
                        height: 0;
                        background: transparent;
                    }
                    &::-webkit-scrollbar-thumb {
                        background-color: rgba(0, 0, 0, 0.3)
                    }
                    th, td {
                        width: 50px;
                        max-width: 50px;
                        min-width: 50px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-align: center;
                    }
                    th {
                        color: #03A9F4;
                        padding: 0;
                        &.average {
                            span {
                                &:first-child {
                                    display: block;
                                    height: 4px;
                                    line-height: 4px;
                                }
                                &:last-child {
                                    display: block;
                                    height: 11px;
                                    line-height: 11px;
                                }
                            }
                        }
                        .lesson {
                            font-size: 11px;
                            color: rgba(74, 39, 243, 0.51);
                        }
                    }
                    td {
                        padding: 0 15px;
                        outline: none;
                        cursor: pointer;
                        &:hover {
                            background: #fafafa;
                            box-shadow: 0 0 20px 0 rgba(74, 39, 243, 0.51);
                        }
                        &.absent-95 {
                            color: #fa1504;
                        }
                        &.average {
                            pointer-events: none;
                        }
                    }
                }
            }

            .disabled {
                background: #eaeaea;
                pointer-events: none;
            }
            .archived {
                pointer-events: none;
                background: #cef9ffe3;
                opacity: 0.5;
            }
        }
            .modal-container {
                position: relative;
            }
            .delete-grade {
                position: absolute;
                top: 15px;
                right: 15px;
                z-index: 1000000000000;
            }
            .header {
                color: #045290;
                &:first-child{
                    margin-bottom: 0;
                }
            }
            .selected-theme {
                pointer-events: none;
                opacity: 0.5;
            }
            .mark-grades {
                .main-marks, .extra-marks {
                    margin-bottom: 15px;
                    span {
                        display: inline-block;
                        &.mark {
                            border: 1px solid;
                            padding: 2px 10px;
                            border-radius: 4px;
                            margin: 0 5px;
                            cursor: pointer;
                            font-weight: bold;
                        }
                        &.selected {
                            color: #fff;
                            background: #00BCD4;
                            border-color: #00BCD4;
                            cursor: default;
                        }
                    }
                }
                .btn-actions {
                    button {
                        background: #60c964;
                        color: #fff;
                        border-radius: 4px;
                        padding: 2px 8px;
                    }
                }
            }
            .theme--light.v-label {
                color: #045290;
            }
            .absent95 {
                .theme--light.v-label {
                    color: #f30404;
                }
            }

    .instructor-quarter-grade {
        padding: 25px;
        font-family: Helvetica, sans-serif;

        .saveGrade {
            position: fixed;
            bottom: 15px;
            width: 100%;
        }

        &__table {
            background: #FFFFFF;
            th, td {
                height: 50px;
                border: #b5b5b5 1px solid;
                min-width: 50px;
                vertical-align: middle;
            }

            thead {
                tr {
                    th:first-child {
                        font-family: Open Sans, sans-serif;
                        font-size: 14px;
                        line-height: 119%;
                        text-align: center;
                        color: #707683;
                    }

                    th {
                        span {
                            border-radius: 5px;
                            height: 40px;
                            font-size: 14px;
                            line-height: 14px;
                            font-weight: bold;
                        }
                    }
                }
            }

            tr {
                height: 50px;
                text-align: center;
                td:not(:first-child) {
                    text-align: center;
                    font-size: 18px;
                    line-height: 21px;
                    letter-spacing: 0.01em;
                    color: #323C47;
                }

                .full-name {
                    min-width: 250px;
                    padding: 0 25px;
                    font-size: 14px;
                    line-height: 16px;
                    letter-spacing: 0.01em;
                }
            }
        }
    }
.v-input--selection-controls {
    margin-top: 0;
}
@media screen and (max-width: 768px) {
    .header{
        position: relative;
    }
    .grade-content {
        width: 100%;
        .selects {
            display: flex;
            flex-direction: column;
            gap: 0;
            width: 100%;
            .ijg-item{
                max-width: none;
                width: 100%;
            }
        }
    }
    .v-data-table {
        max-width: 50%;
    }
}
</style>
